require('../../jsy_do_widokow_z_salami/sale/balkon2/row1.js');
require('../../jsy_do_widokow_z_salami/sale/balkon2/row2.js');
require('../../jsy_do_widokow_z_salami/sale/balkon2/row3.js');
require('../../jsy_do_widokow_z_salami/sale/balkon2/row4.js');
require('../../jsy_do_widokow_z_salami/sale/balkon2/row5.js');